import { render, staticRenderFns } from "./errorTip.vue?vue&type=template&id=66386368&scoped=true&"
import script from "./errorTip.vue?vue&type=script&lang=js&"
export * from "./errorTip.vue?vue&type=script&lang=js&"
import style0 from "./errorTip.vue?vue&type=style&index=0&id=66386368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66386368",
  null
  
)

export default component.exports